module.exports = __webpack_public_path__ + "static/media/lobster-home-tiny.e172b861.jpg";